module.exports = __webpack_public_path__ + "img/etisalat.e3684129.svg";